






























import { Component, Vue } from 'vue-property-decorator';
import { AccountApi } from '@/api/account-api';

const api = new AccountApi();

@Component
export default class LoginForm extends Vue {
    public email: string | null = null;
    public password: string | null = null;
    public showError: boolean = false;

    public get isValid(): boolean {
        return this.email != null && this.email.length > 0 &&
            this.password != null && this.password.length > 0;
    }

    public async login(): Promise<void> {
        this.showError = false;

        if (!this.isValid) {
            return;
        }

        try {
            await api.loginAsync(this.email!, this.password!);
        } catch (e) {
            this.password = null;
            this.showError = true;
            return;
        }

        await this.$store.dispatch('user/fetchMeAsync');
        this.$router.push({ name: 'home' });
    }
}
